import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Modal from "react-animated-modal";
import { PulseLoader } from 'halogenium';
import Select from 'react-select';
import { CancelOrderType, cancelOrderTypes } from '../../app/Common/Enum/CancelOrderType'

var portalRoot = null;

class PhoneNumberAndPaxModalPortal extends React.Component {
    constructor(props) {
        super(props);
        if ($('#confirm-modal').length == 0) {
            $('body').prepend('<div id="confirm-modal"></div>')
        }
        portalRoot = document.getElementById("confirm-modal");
        this.el = document.createElement("div");
    }
    componentDidMount = () => {
        portalRoot.appendChild(this.el);
    };
    componentWillUnmount = () => {
        portalRoot.removeChild(this.el);
    };
    onClose = () => {}
    render() {
        const { children } = this.props;
        return ReactDOM.createPortal(children, this.el);
    }
}
class PhoneNumberAndPaxModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            phoneNumber: this.props.phoneNumber,
            pax: this.props.pax,
            isInvalidPhone: this.props.phoneNumber && !this.checkPhoneNumber(this.props.phoneNumber)
        }
    }
    checkPhoneNumber = (phoneNumber) => {
        if (!phoneNumber) {
            return false
        }
        const regex = /^\+{0,1}6{0,1}0[0-9]{9,11}$/
        return !!phoneNumber.match(regex)
    }
    isLoading(isLoading, callback) {
        if (!this.unmounted) {
            this.setState({isLoading}, () => {callback && callback()})
        }
    }
    componentWillUnmount = () => {
        this.unmounted = true;
        $(document).unbind('keypress', this.enterKeyListener)
        $(document).unbind('keyup',this.escListener);
    };
    componentDidMount = () => {
        // Set reference to that can be removed at componentWillUnmount
        this.enterKeyListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '13'){
                this.onYes()
            }
        }
        this.escListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '27'){
                this.props.onNo && this.props.onNo()
            }
        }
        this.unmounted = false
        $(document).keypress(this.enterKeyListener);
        $(document).keyup(this.escListener);

    };
    onClose = () => {}

    // Parent to call this to dismiss the modal
    close() {
        this.props.onClose()
    }
    onYes = () => {
        if (!this.checkPhoneNumber(this.state.phoneNumber)) {
            this.setState({
                isInvalidPhone: true
            })
            return
        }
        this.props.onYes(this.state.phoneNumber, this.state.pax)
    }
    getButtons = () => {
        if (this.props.buttonLayout == "vertical") {
            return (
                <div className="mt-3">
                    <button id="confirm-modal-btn-yes" onClick={this.onYes} className={"btn btn-block mb-2 "+(this.props.isYesDestructive ? "btn-danger" : "btn-success")}>{this.props.yesText || lang.confirm}</button>
                    <button id="confirm-modal-btn-no" onClick={this.props.onNo} className="btn btn-default btn-block">{this.props.noText || lang.cancel}</button>
                </div>
            )
        }
        else {
            // Default is horizontal layout
            return (
                <div style={{textAlign:"right"}}>
                    <button onClick={this.props.onNo} className="btn btn-primary btn-sm mr-2">{this.props.noText || lang.cancel}</button>
                    <button onClick={this.onYes} className="btn btn-primary btn-sm">{this.props.yesText || lang.confirm}</button>
                </div>
            )
        }
    }
    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    render() {
        return (
            <PhoneNumberAndPaxModalPortal>
                <Modal
                    visible={true}
                    closemodal={this.props.onClose}
                    type="pulse">
                    <div className="menu-modal" style={{padding:"20px"}}>
                        <div>
                            <label htmlFor="phoneNumber">
                                {lang.phone_number}
                            </label>
                            <input autoComplete="off" className="form-control" name="phoneNumber" type="tel" value={this.state.phoneNumber} onChange={this.handleChange}/>
                            {
                                this.state.isInvalidPhone &&
                                <span className="text-danger">* {lang.invalid_phone_number}</span>
                            }
                        </div>
                        <div>
                            <label htmlFor="pax">
                                {lang.pax_label}
                            </label>
                            <input autoComplete="off" className="form-control" name="pax" type="text" value={this.state.pax} onChange={this.handleChange}/>
                        </div>
                        <div className="mt-3"></div>
                        { 
                            this.state.isLoading ? 
                            <PulseLoader color="#ffa733" size="10px" margin="4px" style={{ textAlign: "center" }} /> :
                            this.getButtons()
                        }
                    </div>
                </Modal>
            </PhoneNumberAndPaxModalPortal>
        )
    }
}
PhoneNumberAndPaxModal.defaultProps = {
    customBody:null,
    message: "",
    buttonLayout: "default",
    isYesDestructive: false
}
export default PhoneNumberAndPaxModal;